export enum GrainTransactionImportType {
  Settlements = 'settlements',
  ScaleTickets = 'scale_tickets',
  None = 'none',
}
